import { create } from 'zustand';
import type { NavAction } from '../../services/assistant/navTargets';
import type { ReplySource } from '../../services/assistant/engine';

export interface AssistantMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  actions?: NavAction[];
  source?: ReplySource;
  createdAt: number;
}

interface AssistantState {
  messages: AssistantMessage[];
  awaiting: boolean;
  /** Bumped by clear() so a reply that lands after "New chat" is dropped. */
  epoch: number;
  addMessage: (message: Omit<AssistantMessage, 'id' | 'createdAt'>) => void;
  setAwaiting: (awaiting: boolean) => void;
  clear: () => void;
}

let counter = 0;
const newId = () => `a-${Date.now().toString(36)}-${(counter += 1)}`;

/**
 * The assistant transcript lives outside the panel so closing and
 * reopening the assistant (or navigating via one of its links) keeps the
 * conversation. It is in memory only: portfolio figures are never written
 * to browser storage.
 */
export const useAssistantStore = create<AssistantState>((set) => ({
  messages: [],
  awaiting: false,
  epoch: 0,
  addMessage: (message) =>
    set((state) => ({ messages: [...state.messages, { ...message, id: newId(), createdAt: Date.now() }] })),
  setAwaiting: (awaiting) => set({ awaiting }),
  clear: () => set((state) => ({ messages: [], awaiting: false, epoch: state.epoch + 1 })),
}));
